import { useEffect, useState } from 'react';
import { History, ChevronDown, ChevronUp } from 'lucide-react';
import { adminAPI } from '../../services/api';

const inr = (v) => `₹${Math.round(v || 0).toLocaleString('en-IN')}`;

const ReportRow = ({ r }) => (
  <tr className="border-t border-gray-100" data-testid={`backfill-row-${r.user_id}`}>
    <td className="px-3 py-2"><div className="font-medium text-gray-900">{r.name}</div><div className="text-xs text-gray-500">{r.phone}</div></td>
    <td className="px-3 py-2 text-right text-gray-600">{inr(r.before_total)}</td>
    <td className="px-3 py-2 text-right font-medium text-gray-900">{inr(r.after_total)}</td>
    <td className="px-3 py-2 text-right text-green-700">+{inr(r.added_amount)}</td>
    <td className="px-3 py-2 text-right text-gray-900">{inr(r.total_now)}</td>
    <td className="px-3 py-2 capitalize text-gray-700">{r.pan_status.replace('_', ' ')}</td>
    <td className="px-3 py-2">
      {r.needs_pan
        ? <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-red-100 text-red-700" data-testid="backfill-needs-pan">Needs PAN</span>
        : <span className="text-xs text-gray-400">-</span>}
    </td>
  </tr>
);

export const BuyTotalBackfillReport = () => {
  const [report, setReport] = useState(null);
  const [open, setOpen] = useState(false);
  const [onlyNeedsPan, setOnlyNeedsPan] = useState(false);

  useEffect(() => {
    adminAPI.getBuyTotalBackfillReport().then((r) => setReport(r.data)).catch(() => setReport(null));
  }, []);

  if (!report) return null;
  const rows = onlyNeedsPan ? report.rows.filter((r) => r.needs_pan) : report.rows;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 mb-6" data-testid="backfill-report">
      <button onClick={() => setOpen(!open)} data-testid="backfill-report-toggle"
        className="w-full flex items-center justify-between gap-3 p-4 text-left">
        <div className="flex items-center gap-3">
          <History className="w-5 h-5 text-amber-600" />
          <div>
            <p className="font-semibold text-gray-900">Booking total corrections (UPI recount)</p>
            <p className="text-xs text-gray-500" data-testid="backfill-report-summary">
              {report.has_run
                ? `Ran ${new Date(report.ran_at).toLocaleString('en-IN')} · ${report.users_corrected} users corrected · ${report.users_needing_pan} now need PAN`
                : 'Not run yet — runs once on the next server start'}
            </p>
          </div>
        </div>
        {open ? <ChevronUp className="w-5 h-5 text-gray-400" /> : <ChevronDown className="w-5 h-5 text-gray-400" />}
      </button>
      {open && (
        <div className="border-t border-gray-100 p-4">
          <label className="flex items-center gap-2 text-sm text-gray-700 mb-3">
            <input type="checkbox" checked={onlyNeedsPan} onChange={(e) => setOnlyNeedsPan(e.target.checked)} data-testid="backfill-only-needs-pan" />
            Show only users who now need PAN
          </label>
          {rows.length === 0 ? (
            <p className="text-sm text-gray-500" data-testid="backfill-report-empty">No users to show.</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="text-xs text-gray-500 uppercase">
                  <tr>
                    <th className="px-3 py-2 text-left">User</th><th className="px-3 py-2 text-right">Before</th>
                    <th className="px-3 py-2 text-right">After recount</th><th className="px-3 py-2 text-right">Added</th>
                    <th className="px-3 py-2 text-right">Total now</th><th className="px-3 py-2 text-left">PAN</th><th className="px-3 py-2" />
                  </tr>
                </thead>
                <tbody>{rows.map((r) => <ReportRow key={r.user_id} r={r} />)}</tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
